import { Link } from "react-router-dom";
import { ArrowRight, Leaf, Heart, Sparkles, Target } from "lucide-react";
import { aboutImage } from "../mock";

const values = [
  { icon: Heart, title: "Passione", text: "Il verde è la nostra vita da tre generazioni. Ogni giardino è una storia che curiamo con dedizione." },
  { icon: Sparkles, title: "Qualità", text: "Materiali selezionati, tecniche moderne, attrezzature professionali per risultati che durano nel tempo." },
  { icon: Target, title: "Precisione", text: "Ogni intervento è progettato su misura, con l'attenzione artigianale per ogni singolo dettaglio." },
  { icon: Leaf, title: "Sostenibilità", text: "Rispettiamo la natura e l'ambiente scegliendo pratiche rispettose degli ecosistemi." },
];

export default function ChiSiamo() {
  return (
    <div>
      {/* PAGE HERO */}
      <section className="relative pt-40 pb-24 bg-sage-50 overflow-hidden">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <div className="max-w-3xl reveal">
            <span className="text-xs tracking-[0.3em] uppercase text-sage-600">Chi siamo</span>
            <h1 className="font-serif text-5xl md:text-7xl text-sage-900 mt-4 leading-[1.05]">
              Il lavoro:<br />
              <span className="italic text-sage-700">la nostra passione</span> sin da piccoli.
            </h1>
          </div>
        </div>
      </section>

      {/* STORY */}
      <section className="py-24 md:py-32 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <div className="max-w-3xl mx-auto reveal">
            <img src={aboutImage} alt="Il team" className="w-full max-h-[500px] object-contain rounded shadow-xl bg-sage-50" />
          </div>
        </div>
      </section>

      {/* VALUES */}
      <section className="py-24 md:py-32 bg-cream">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <div className="max-w-2xl mb-16 reveal">
            <span className="text-xs tracking-[0.3em] uppercase text-sage-600">Cosa ci guida</span>
            <h2 className="font-serif text-4xl md:text-5xl text-sage-900 mt-4">I nostri valori</h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {values.map((v, i) => (
              <div key={v.title} className="bg-white p-10 rounded hover:shadow-lg transition-all duration-500 reveal" style={{ transitionDelay: `${i * 80}ms` }}>
                <div className="w-14 h-14 rounded-full bg-sage-100 flex items-center justify-center mb-6">
                  <v.icon className="w-6 h-6 text-sage-700" strokeWidth={1.5} />
                </div>
                <h3 className="font-serif text-2xl text-sage-900 mb-3">{v.title}</h3>
                <p className="text-sage-800/70 leading-relaxed">{v.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-24 bg-white">
        <div className="max-w-4xl mx-auto px-6 lg:px-10 text-center reveal">
          <h2 className="font-serif text-4xl md:text-5xl text-sage-900 mb-6">Iniziamo a lavorare insieme.</h2>
          <p className="text-lg text-sage-700/80 mb-10">
            Raccontaci il tuo desiderio. Verremo a trovarti per un sopralluogo e un preventivo gratuito, senza alcun impegno.
          </p>
          <Link to="/contatti" className="inline-flex items-center gap-3 px-8 py-4 bg-sage-700 text-white rounded-full text-sm tracking-wide hover:bg-sage-800 transition-all">
            Contattaci <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </section>
    </div>
  );
}
